import React from "react";
import GuideStep from "components/InstallationGuide/GuideStep";
import GuideHeading from "components/InstallationGuide/GuideHeading";
import GuideParagraph from "components/InstallationGuide/GuideParagraph";
import CopyableCodeSnippet from "components/Common/CopyableCodeSnippet";
import {
  PAGE_CHANGE_SNIPPETS,
  HTML,
  ANGULAR,
  REACT,
  EMBER,
  VUE
} from "constants/installation/snippets";

const isSinglePageFramework = framework =>
  framework === ANGULAR ||
  framework === REACT ||
  framework === EMBER ||
  framework === VUE;

const InstallPageCall = props => {
  const {
    moveForward,
    moveBackward,
    selectedInstallFramework,
    stepMax,
    stepIndex
  } = props;

  const pageChangeSnippet =
    PAGE_CHANGE_SNIPPETS[selectedInstallFramework || HTML];

  const isSinglePage = isSinglePageFramework(selectedInstallFramework);

  return (
    <GuideStep
      stepIndex={stepIndex}
      stepMax={stepMax}
      title="Re-initialize Appcues upon page change"
      moveForward={moveForward}
      moveBackward={moveBackward}
    >
      <GuideHeading>WHY</GuideHeading>
      {isSinglePage ? (
        <GuideParagraph>
          Appcues triggers the display of content on page load. Since single
          page apps can change URLs or re-render pages without actually
          reloading the page, calling the <code>Appcues.page()</code> method
          will notify Appcues that the page has changed and it should check
          again for content.
        </GuideParagraph>
      ) : (
        <GuideParagraph>
          If you change the URL or page with Javascript within your app, you
          need to tell Appcues that the page has changed. To do so, call{" "}
          <code>{`Appcues.page()`}</code> when the URL or page changes. That
          way, Appcues will pick up the new path and check if any content should
          show up.
        </GuideParagraph>
      )}
      <GuideHeading>HOW</GuideHeading>
      {isSinglePage ? (
        <GuideParagraph>
          You'll need to call <code>{`Appcues.page()`}</code> after each URL
          change. This is typically done in your application's router and is
          handled after a successful page change.
        </GuideParagraph>
      ) : (
        <GuideParagraph>
          Make this call whenever you use JavaScript to change a significant
          amount of the page.{" "}
        </GuideParagraph>
      )}
      {isSinglePage && (
        <CopyableCodeSnippet>{pageChangeSnippet}</CopyableCodeSnippet>
      )}
    </GuideStep>
  );
};

export default InstallPageCall;
